import { theme } from "@covertree/theme";
import { Box, Grid, Typography } from "@mui/material";

interface Props {
  readonly total: string;
  readonly totalColor: string;
  readonly totalLabel: string;
  readonly isTotalChanged: boolean;
  readonly premium: string;
  readonly tax: string;
  readonly fees: string;
}

export function TotalChange({
  total,
  totalColor,
  totalLabel,
  isTotalChanged,
  premium,
  tax,
  fees,
}: Props) {
  return (
    <>
      <Typography variant="caption" color="text.secondary" fontSize={16}>
        Total Change (Prorated)
      </Typography>
      <Typography variant="h3" fontWeight={"500"} color={totalColor}>
        {total}
      </Typography>
      <Typography variant="caption" fontSize={16} display="block" mb={1.5}>
        <Box component="span" color={totalColor}>
          {totalLabel}
        </Box>
        {isTotalChanged && (
          <Box component="span" color="text.secondary">
            {" "}
            incl. tax and fees
          </Box>
        )}
      </Typography>
      <Grid container>
        <Grid item xs={8}>
          <Typography variant="caption" color="text.secondary" fontSize={16}>
            Premium
          </Typography>
        </Grid>
        <Grid item xs={4} display="flex" justifyContent="right">
          <Typography variant="caption" color="text.secondary" fontSize={16}>
            {premium}
          </Typography>
        </Grid>
        <Grid item xs={8} marginTop={theme.spacing(-0.5)}>
          <Typography variant="caption" color="text.secondary" fontSize={16}>
            Tax
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          display="flex"
          justifyContent="right"
          marginTop={theme.spacing(-0.5)}>
          <Typography variant="caption" color="text.secondary" fontSize={16}>
            {tax}
          </Typography>
        </Grid>
        <Grid item xs={8} marginTop={theme.spacing(-0.5)}>
          <Typography variant="caption" color="text.secondary" fontSize={16}>
            Fees
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          display="flex"
          justifyContent="right"
          marginTop={theme.spacing(-0.5)}>
          <Typography variant="caption" color="text.secondary" fontSize={16}>
            {fees}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
